import { useEffect, useState } from "react";
import {
    Button,
    DialogActions,
    DialogContent,
    FormControl,
    InputLabel,
    MenuItem,
    Select,
    Stack,
    TextField,
} from "@mui/material";
import DialogHeader from "../../../components/Dialog/DialogHeader";
import UserDialog from "../../../components/Dialog/UserDialog";
import { Api } from "../../../request/api/api";
import { Status } from "../../../model/Types";

interface EditFighterInfoDialogProps {
    open: boolean;
    onClose: () => void;
    fetchData: () => void;
    fighterId: string;
    currentName: string;
    currentRank: string;
    currentStatus: Status | null;
}

export default function EditFighterInfoDialog({
    open,
    onClose,
    fetchData,
    fighterId,
    currentName,
    currentRank,
    currentStatus,
}: EditFighterInfoDialogProps) {
    const [name, setName] = useState("");
    const [rank, setRank] = useState("");
    const [status, setStatus] = useState<number>(Status.ACTIVE);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState<string | null>(null);

    useEffect(() => {
        if (open) {
            setName(currentName);
            setRank(currentRank);
            setStatus(currentStatus ?? Status.ACTIVE);
            setError(null);
        }
    }, [open, currentName, currentRank, currentStatus]);

    const handleSave = async () => {
        if (!name.trim()) { setError("Введите имя бойца"); return; }
        if (!rank.trim()) { setError("Введите ранг бойца"); return; }

        setLoading(true);
        setError(null);

        const ok = await Api.fighter.editFighterInfo(fighterId, name.trim(), rank.trim(), status);

        setLoading(false);

        if (ok) {
            fetchData();
            onClose();
        } else {
            setError("Ошибка при сохранении");
        }
    };

    const handleClose = () => { setError(null); onClose(); };

    return (
        <UserDialog handleClose={handleClose} open={open} error={error}>
            <DialogHeader loading={loading} title="Редактировать информацию о бойце" />
            <DialogContent>
                <Stack spacing={2} sx={{ mt: 1 }}>
                    <TextField
                        label="Имя бойца"
                        value={name}
                        onChange={e => setName(e.target.value)}
                        fullWidth
                        disabled={loading}
                        autoFocus
                    />
                    <TextField
                        label="Ранг"
                        value={rank}
                        onChange={e => setRank(e.target.value)}
                        fullWidth
                        disabled={loading}
                    />
                    <FormControl fullWidth disabled={loading}>
                        <InputLabel>Статус</InputLabel>
                        <Select
                            value={status}
                            label="Статус"
                            onChange={e => setStatus(Number(e.target.value))}
                        >
                            <MenuItem value={Status.ACTIVE}>Активен</MenuItem>
                            <MenuItem value={Status.ON_RECOVERY}>На восстановлении</MenuItem>
                            <MenuItem value={Status.DEAD}>Мёртв</MenuItem>
                        </Select>
                    </FormControl>
                </Stack>
            </DialogContent>
            <DialogActions>
                <Button onClick={handleClose} disabled={loading}>Отмена</Button>
                <Button onClick={handleSave} variant="contained" disabled={loading}>
                    {loading ? "Сохранение..." : "Сохранить"}
                </Button>
            </DialogActions>
        </UserDialog>
    );
}
